function showStars(val,num_rated) {
    var rating =
        '<div class="wrap-rating">' +
        '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(1, val) +'"></i>' +
        '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(2, val) +'"></i>' +
        '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(3, val) +'"></i>' +
        '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(4, val) +'"></i>' +
        '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(5, val) +'"></i>' +
        '<span>' + num_rated + '</span>' +
        '</div>' ;
    return rating;
}

function editStars(selector,val) {
    selector.html(`
        <div class="wrap-rating">
             <i class="fa fa-star" aria-hidden="true" style="color:`+getStarColor(1,val)+`"></i>
             <i class="fa fa-star" aria-hidden="true" style="color:`+getStarColor(2,val)+`"></i>
             <i class="fa fa-star" aria-hidden="true" style="color:`+getStarColor(3,val)+`"></i>
             <i class="fa fa-star" aria-hidden="true" style="color:`+getStarColor(4,val)+`"></i>
             <i class="fa fa-star" aria-hidden="true" style="color:`+getStarColor(5,val)+`"></i>
        `)
}
function getStarColor(starPosition,markerStar) {
    if (markerStar){
        return starPosition <= markerStar ? "#EDB867" : "#d2d2d2";
    }
    return "#d2d2d2"
}
 module.exports = {
     showStars: showStars,
     editStars:editStars
 };


// WEBPACK FOOTER //
// ./resources/assets/js/stars.js